
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M.412 21.089c.547.548 1.43.548 1.977 0l9.284-9.3a1.116 1.116 0 000-1.578L2.389.911a1.4 1.4 0 00-1.977 1.98L8.5 11.006.4 19.119a1.397 1.397 0 00.012 1.97z","fill-rule":"evenodd"}})])
          )
        }
      }
    